import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { MdPlayArrow } from "react-icons/md";
import Description from "./Description";
import "./tab.scss";

import Aos from "aos";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: "100%",
  },
  tabs: {
    padding: "20px",
    margin: "10px",
    background: "#f9f9f9",
    width: "100%",
  },
}));

export default function VerticalTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  Aos.init({
    delay: 500,
    once: true,
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    // document.title = "Lab Reports | Data Insights | Galaxy Gemological Institute";
  }, []);
  return (
    <div>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/laboratory/lab-reports"
        />

        <title>
          Galaxy Gemological Institute: Lab Reports - GGILab
        </title>
        <meta
          name="description"
          content="Galaxy Gemological Institute provides reliable gemstone lab reports. Trust GGI for expert certifications and detailed gemstone evaluations."
        />
      </Helmet>
      <div className="parentTab">
        <div className={classes.root}>
          <div className="tabPanelCustom">
            <div className="TabSection">
              <div className={classes.tabs}>
                <Tabs
                  data-aos="zoom-out-left"
                  orientation="vertical"
                  className="tabpanel"
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                >
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Diamond Seal"
                    {...a11yProps(0)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Gemstone Seal"
                    {...a11yProps(1)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Master Gemstone Certificate"
                    {...a11yProps(2)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Diamond Certificate"
                    {...a11yProps(3)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Gemstone Certificate"
                    {...a11yProps(4)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Jewellery Certificate"
                    {...a11yProps(5)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Diamond Brief Report"
                    {...a11yProps(6)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Gemstone Brief Report"
                    {...a11yProps(7)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Jewellery Brief Report"
                    {...a11yProps(8)}
                  />
                  <Tab
                    className="tabs"
                    data-aos="fade-down-left"
                    icon={<MdPlayArrow />}
                    label="Consultation"
                    {...a11yProps(9)}
                  />
                </Tabs>
              </div>
            </div>
            <TabPanel value={value} index={0}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903404/DiamondSeal_smq4az.webp"
                }
                img2={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903391/Diamond_Seal_back_lz4l96.webp"
                }
                heading={"Diamond Seal"}
                paragraph={[
                  "Cut, color, clarity & carat weight",
                  "Diamond is sealed in a secure tamper-proof container.",
                  "GGI report is enclosed within the seal, and is visible from the back of the seal.",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903425/GemStoneSeal_phfxrj.webp"
                }
                img2={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903424/GemStoneSealBack_xemusa.webp"
                }
                heading={"Gemstone Seal"}
                paragraph={[
                  "Weight, Dimension & Cut.",
                  "Description of Color.",
                  "Identification of the stone.",
                  "Gemstone is sealed in a secure tamper-proof container.",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903431/Master_Gemstone_e7zn6o.webp"
                }
                imgClass="fullImg"
                heading={"Master Gemstone Certificate"}
                paragraph={[
                  "Weight, Dimension & Cut.",
                  "Description of Color & Transparency.",
                  "Identification of the stone.",
                  "Microscopic evidence.",
                  "Identifies and describes a material and lists detectable treatments.",
                  "Photograph of gemstone.",
                  "Clarity Grade.",
                  "Color Grade.",
                  "Cut Grade.",
                  "Instruments used.",
                  "Origin, if requested by client",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903398/diamondcertificate_m8bgyf.webp"
                }
                heading={"Diamond Certificate"}
                imgClass="fullImg"
                paragraph={[
                  "Cut, color, clarity & carat weight",
                  "Treatments.",
                  "Plotting.",
                  "Diamond and key grading information sealed in compact package.",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903426/Gemstonecertificate_idwky6.webp"
                }
                imgClass="fullImg"
                heading={"Gemstone Certificate"}
                paragraph={[
                  "Weight, Dimension & Cut.",
                  "Description of Color & Transparency.",
                  "Identification of the stone.",
                  "Identifies and describes a material and lists detectable treatments.",
                  "Photograph of gemstone.",
                  "Origin, if requested by client",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903427/jewlrycertificate_aormci.webp"
                }
                imgClass="fullImg"
                heading={"Jewellery Certificate"}
                paragraph={[
                  "Article’s total weight.",
                  "Complete detail of gem/s, if any, studded in the jewellery.",
                  "Colour, shape, cut, clarity & weight of each gem.",
                  "Karatage of metal mentioned on client’s request.",
                  "Grades, weight & measurements are approximate as permitted by mounting",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={6}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903395/Diamond_Report_ibissb.webp"
                }
                imgClass="fullImg"
                heading={"Diamond Brief Report"}
                paragraph={[
                  "Cut, color, clarity & carat weight.",
                  "Treatments.",
                  "Photograph of Diamond.",
                  "Fluorescence.",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={7}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903423/GemstoneReport_iskmsq.webp"
                }
                imgClass="fullImg"
                heading={"Gemstone Brief Report"}
                paragraph={[
                  "Weight, Dimension & Cut",
                  "Description of Color & Transparency.",
                  "	Identification of the stone.",
                  "Identifies and describes a material and lists detectable treatments.",
                  "Photograph of Gemstone.",
                  "Origin, if requested by client",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={8}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903426/JewelleryReport_qjoc28.webp"
                }
                imgClass="fullImg"
                heading={"Jewellery Brief Report"}
                paragraph={[
                  "Approximate weight & measurements as permitted by mounting.",
                  "Color, Cut & Transparency.",
                  "Identification of stone.",
                  "Treatments.",
                  "Photograph of a jewellery.",
                ]}
              />
            </TabPanel>
            <TabPanel value={value} index={9}>
              <Description
                img1={
                  "https://res.cloudinary.com/ggi/image/upload/v1637903388/consultation_Piic_tteku5.webp"
                }
                imgClass="fullImg"
                heading={"Consultation"}
                paragraph={[
                  "Color & Cut description.",
                  "Weight & dimension.",
                  "Identification of stone.",
                  "Treatments.",
                ]}
              />
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}
